module.exports = __webpack_public_path__ + "img/titanium-vein.241eea2e.png";